// test49
(49 && 0);
